import EmptyRouterView from '@/components/common/EmptyRouterView'

// Awizacje, Portiernia
import ShippingNotification from '@/views/Shipping/Notification/Index'
import ShippingNotificationGateHouse from '@/views/Shipping/NotificationGateHouse/Index'
import ShippingNotificationConfigurations from '@/views/Shipping/Configurations/Index'

export default [
    {
        path: '',
        component: EmptyRouterView,
        meta: {
            title: 'Spedycja',
            menuRendered: true,
            menuTitle: 'Spedycja',
            icon: 'mdi-truck'
        },
        children: [
            {
                path: '/shipping/notification/notification',
                name: 'shippingNotification',
                component: ShippingNotification,
                meta: {
                    title: 'Spedycja / Awizacje',
                    menuRendered: true,
                    menuTitle: 'Awizacje',
                    requiresAuth: true,
                    permission: 'notification'
                },
            },
            {
                path: '/shipping/notification/gate-house',
                name: 'shippingNotificationGateHouse',
                component: ShippingNotificationGateHouse,
                meta: {
                    title: 'Spedycja / Portiernia',
                    menuRendered: true,
                    menuTitle: 'Portiernia',
                    requiresAuth: true,
                    permission: 'notification_gate'
                },
            },
            {
                path: '/shipping/notification/configurations',
                name: 'shippingNotificationConfigurations',
                component: ShippingNotificationConfigurations,
                meta: {
                    title: 'Spedycja / Konfiguracje',
                    menuRendered: true,
                    menuTitle: 'Konfiguracje',
                    requiresAuth: true,
                    permission: 'notification'
                },
            }
        ]
    }
]
